<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_vii"><b>CONTENTS</b></a></p><a id="page_vii">
</a><p class="toc"><a id="page_vii"></a><a href="#/xhtml/07_Introduction">Introduction</a></p>
<p class="tocat"><a href="#/xhtml/08_Chapter01">1.  Origins of the Foreign Policy Partnership, 1801–1861</a></p>
<p class="toca"><span href="#/xhtml/09_Chapter02" title="Link target outside of Sample">2.  The First Perilous Year, 1861</span></p>
<p class="toca"><span href="#/xhtml/10_Chapter03" title="Link target outside of Sample">3.  The Recognition and Cabinet Crises, 1862</span></p>
<p class="toca"><span href="#/xhtml/11_Chapter04" title="Link target outside of Sample">4.  Victory and the Death of the Partnership, 1863–1865</span></p>
<p class="toca"><span href="#/xhtml/12_Chapter05" title="Link target outside of Sample">5.  Seward and Empire, 1865–1869</span></p>
<p class="toc"><span href="#/xhtml/13_Conclusion" title="Link target outside of Sample">Conclusion</span></p>
<p class="toct"><span href="#/xhtml/14_Acknowledgments" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc"><span href="#/xhtml/15_Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/xhtml/16_Bibliography" title="Link target outside of Sample">Bibliographic Essay</span></p>
<p class="toc"><span href="#/xhtml/17_Index01" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Contents.vue?720ae666